import React from "react";
import { Link } from "react-router-dom";

const INDEX = [
  { n: "01", title: "projects & learnings", to: "/projects" },
  { n: "02", title: "essays", to: "/essays" },
  { n: "03", title: "travel", to: "/travel" },
];

function Home() {
  return (
    <main className="home-main fade-up">
      <div className="home-index">
        {INDEX.map((row) => (
          <Link key={row.n} to={row.to} className="home-row">
            <span className="home-row-n">{row.n}</span>
            <span className="home-row-title">{row.title}</span>
            <span className="home-row-arrow">→</span>
          </Link>
        ))}
      </div>
    </main>
  );
}

export default Home;
